import axios from "axios";
import { useState } from "react";

const usePostEvent = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState<unknown>({});
  // api data promise
  const apiDataPromise = async (url: string, postData: unknown) => {
    try {
      setLoading(true);
      const { data } = await axios.post(url, postData, {
        // headers: {
        //   ...authorizationToken(loginData!),
        // },
      });
      setData(data.results);
      setLoading(false);
    } catch (error: any) {
      setError(error.response.data.responseMessage);
      setLoading(false);
    }
  };

  return {
    loading,
    data,
    error,
    apiDataPromise,
  };
};

export const usePostEventTrue = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [data, setData] = useState<unknown>({});
  // api data promise
  const apiDataPromise = async (url: string, postData: unknown) => {
    try {
      setLoading(true);
      const { data } = await axios.post(url, postData, {

      });
      setData(data.results);
      setLoading(false);
    } catch (error: any) {
      setError(error.response.data.responseMessage);
      setLoading(false);
    }
  };

  return {
    loading,
    data,
    error,
    apiDataPromise,
  };
};

export default usePostEvent;
